import { render, staticRenderFns } from "./AzulPendenciesDetail.vue?vue&type=template&id=0a192b7a&scoped=true"
import script from "./AzulPendenciesDetail.vue?vue&type=script&lang=js"
export * from "./AzulPendenciesDetail.vue?vue&type=script&lang=js"
import style0 from "../PendenciesDetail/styles.scss?vue&type=style&index=0&id=0a192b7a&prod&scoped=true&lang=scss&external"
import style1 from "./AzulPendenciesDetail.vue?vue&type=style&index=1&id=0a192b7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a192b7a",
  null
  
)

export default component.exports